<template>
  <div class="Dialog prize" v-if="showWinPrize" >
    <div class="inner">
      <div class="pic-bg"></div>
      <div class="pic-birld"></div>
      <div class="pic-cloud"></div>

      <div class="icon-close" @click="send('CLOSE_DRAW_DIALOG')"></div>
      <div class="title"><span>宝箱开奖</span></div>

      <div class="inner-body">
        <p class="desc" v-if="drawSuccess">恭喜你抽中奖品啦！</p>
        <div class="prize-box" v-if="showAnimate" >
          <!-- <img src="./assets/prize.png" /> -->
          <!-- woddle晃动 后 hide隐藏再切换至奖品图 -->
          <img  :class="{'wobble':showAnimate}" v-if="state.context.selectedPresentRank<7" src="../../../../ui/20201111king_double_eleven/assets/green-box-lg.png">
          <img  :class="{'wobble':showAnimate}" v-else src="../../../../ui/20201111king_double_eleven/assets/red-box-lg.png">
        </div>
        <div class="prize-box" v-else-if="drawSuccess">
          <img :src="state.context.award.url">
          <p class="prize-name">{{state.context.award.name}}</p>
        </div>
        <div class="prize-box" v-else-if="drawError">
          <img  v-if="state.context.selectedPresentRank<7"  src="../../../../ui/20201111king_double_eleven/assets/green-box-lg.png">
          <img  v-else src="../../../../ui/20201111king_double_eleven/assets/red-box-lg.png">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "@vue/composition-api"
export default {
  name: "Award",
  props: ["state", "send"],
  setup(props) {
    const showWinPrize = computed(() => {
      return [
        "participate.luckydraw.showDrawDialog.drawPresent"
        // "participate.luckydraw.queryAward.success",
        // "participate.luckydraw.showAward"
      ].some(props.state.matches)
    })

    const drawSuccess = computed(() => {
      return ["participate.luckydraw.showDrawDialog.drawPresent.success"].some(props.state.matches)
    })

    const showAnimate = computed(() => {
      return [
        "participate.luckydraw.showDrawDialog.receiveTaskPresent.pending",
        "participate.luckydraw.showDrawDialog.getDrawCoupon.pending",
        "participate.luckydraw.showDrawDialog.drawPresent.pending"

        // "participate.luckydraw.queryAward.success",
        // "participate.luckydraw.showAward"
      ].some(props.state.matches)
    })

    const drawError = computed(() => {
      return [
        "participate.luckydraw.showDrawDialog.drawPresent.failure"
        // "participate.luckydraw.queryAward.success",
        // "participate.luckydraw.showAward"
      ].some(props.state.matches)
    })

    return {
      showWinPrize,
      showAnimate,
      drawSuccess,
      drawError
    }
  }
}
</script>

<style scoped>
</style>
